(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/service-wager/assets/utils/fetch-additional-draw-info.js') >= 0) return;  svs.modules.push('/components/payment/service-wager/assets/utils/fetch-additional-draw-info.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$utils$products = svs.utils.products,
  productIds = _svs$utils$products.productIds,
  getSpecificDrawName = _svs$utils$products.getSpecificDrawName;
const jupiterFetch = svs.core.jupiterFetch;
const CurrencyAsJupiterString = svs.utils.format.CurrencyAsJupiterString;
const _svs$components$lbUti = svs.components.lbUtils.apiProxy,
  ApiProxy = _svs$components$lbUti.ApiProxy,
  http = _svs$components$lbUti.http,
  featureToggle = _svs$components$lbUti.featureToggle;
const cloudApiFeatureToggles = svs.components.lbUtils.cloudApi.cloudApiConstants.cloudApiFeatureToggles;
const jackpotCache = {};
const drawInfoCache = {};
const jackpotProducts = [productIds.STRYKTIPSET, productIds.EUROPATIPSET, productIds.FULLTRAFF, productIds.MALTIPSET];
const getCacheKey = _ref => {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber;
  return "".concat(productId, "_").concat(drawNumber);
};
const parseDraw = draw => {
  var _draw$fund, _draw$fund2;
  return _objectSpread(_objectSpread({}, draw), {}, {
    fund: _objectSpread(_objectSpread({}, draw.fund), {}, {
      rolloverIn: draw === null || draw === void 0 || (_draw$fund = draw.fund) === null || _draw$fund === void 0 ? void 0 : _draw$fund.rolloverIn.replace(',', '.'),
      extraMoney: draw === null || draw === void 0 || (_draw$fund2 = draw.fund) === null || _draw$fund2 === void 0 ? void 0 : _draw$fund2.extraMoney.replace(',', '.')
    })
  });
};

const fetchInfoForProducts = async (products, jackpots) => {
  const customHandler = http.get('/draw/1/:product/draws/:drawNumber', _ref2 => {
    let data = _ref2.data;
    return data;
  }, {
    config: {
      shouldUseCloud: async options => {
        const isEnabled = await featureToggle(cloudApiFeatureToggles[options.productName.toUpperCase()], {
          req: undefined
        });
        return isEnabled;
      },
      allowedProducts: ['bomben', 'matchen', 'europatipset', 'stryktipset'],
      cloudEndpointTemplate: '/v1/:product/draws/:drawNumber'
    }
  });
  const drawsPaths = [];
  for (const _ref3 of products) {
    const productId = _ref3.productId;
    const drawNumber = _ref3.drawNumber;
    const productName = getSpecificDrawName(productId);
    drawsPaths.push({
      url: "/draw/1/".concat(productName, "/draws/").concat(drawNumber),
      productName
    });
  }
  const apiProxy = new ApiProxy([customHandler]);
  const allDrawsPromises = drawsPaths.map(_ref4 => {
    let url = _ref4.url,
      productName = _ref4.productName;
    return apiProxy.fetch(url, {
      method: 'GET',
      productName
    });
  });
  const drawsResponse = await Promise.allSettled(allDrawsPromises);
  const drawsResponses = drawsResponse.map(drawResponse => {
    if (drawResponse.status === 'rejected') {
      throw new Error("'Error fetching product info' ".concat(drawResponse.reason));
    }
    return {
      deviceId: drawResponse.value.deviceId,
      error: drawResponse.value.error,
      requestId: drawResponse.value.requestId,
      requestInfo: drawResponse.value.requestInfo,
      draw: {
        fund: drawResponse.value.draw.fund,
        regOpenTime: drawResponse.value.draw.regOpenTime
      }
    };
  });
  const drawData = {};
  for (let i = 0; i < products.length; i++) {
    const key = getCacheKey(products[i]);
    const response = drawsResponses[i];
    drawData[key] = response.error ? {} : parseDraw(response.draw);
    drawInfoCache[key] = drawData[key];
  }
  const jackpotPaths = [];
  for (const _ref5 of jackpots) {
    const productId = _ref5.productId;
    const productDrawName = getSpecificDrawName(productId);
    const jackpotPath = ["/draw/1/jackpot/".concat(productDrawName, "?include="), encodeURIComponent(['jackpot.jackpots.jackpotAmount', 'jackpot.guaranteedJackpots.jackpotAmount'].join(','))].join('');
    jackpotPaths.push(jackpotPath);
  }
  let jackpotResponse;
  if (jackpotPaths.length > 0) {
    jackpotResponse = await Promise.all(jackpotPaths.map(jackpotPath => jupiterFetch.fetch(jackpotPath, {
      method: 'GET'
    })));
  }
  const jackpotResponses = jackpotPaths.length && jackpotResponse ? await Promise.all(jackpotResponse.map(res => res.json())) : [];
  const jackpotData = {};
  for (let i = 0; i < jackpots.length; i++) {
    const productId = jackpots[i].productId;
    const response = (jackpotResponses === null || jackpotResponses === void 0 ? void 0 : jackpotResponses.length) > 0 ? jackpotResponses[i] : null;
    jackpotData[productId] = [];
    if (!response.error) {
      const jp = response.jackpot.jackpots.map(_ref6 => {
        let jackpotAmount = _ref6.jackpotAmount;
        return CurrencyAsJupiterString(jackpotAmount).replace(',', '.');
      });
      const gjp = response.jackpot.guaranteedJackpots.map(_ref7 => {
        let jackpotAmount = _ref7.jackpotAmount;
        return CurrencyAsJupiterString(jackpotAmount).replace(',', '.');
      });
      jackpotData[productId] = [...jp, ...gjp];
    }
    jackpotCache[productId] = jackpotData[productId];
  }
  return {
    draws: drawData,
    jackpots: jackpotData
  };
};

const fetchAdditionalDrawInfo = async products => {
  const productsToFetch = products.filter(product => {
    const key = getCacheKey(product);
    return !drawInfoCache[key];
  });
  const jackpotsToFetch = products.filter(_ref8 => {
    let productId = _ref8.productId;
    return !jackpotCache[productId] && jackpotProducts.includes(productId);
  });
  if (productsToFetch.length || jackpotsToFetch.length) {
    await fetchInfoForProducts(productsToFetch, jackpotsToFetch);
  }
  const retJackpot = {};
  const retDraw = {};
  for (const product of products) {
    const productId = product.productId;
    if (jackpotCache[productId]) {
      retJackpot[productId] = jackpotCache[productId];
    }
    const key = getCacheKey(product);
    retDraw[key] = drawInfoCache[key];
  }
  return {
    jackpots: retJackpot,
    draws: retDraw
  };
};
const emptyObject = obj => {
  const keys = Object.keys(obj);
  for (const key of keys) {
    delete obj[key];
  }
};
const clearCache = () => {
  emptyObject(jackpotCache);
  emptyObject(drawInfoCache);
};
fetchAdditionalDrawInfo.clearCache = clearCache;
setGlobal('svs.components.payment.serviceWager.utils.fetchAdditionalDrawInfo', fetchAdditionalDrawInfo);

 })(window);